import { BMCheckbox } from "@traveloka/district-bloom";
import { Pressable, StyleProp, ViewStyle } from "react-native";
import HighlightText from "../../../../components/HighlightText/HighlightText";
import BMView from "../../../../components/View/BMView";
import { useTravelerPickerContextV2 } from "../../../../providers/TravelerPickerContextV2";
import { Employee } from "./types";

type Props = {
  style?: StyleProp<ViewStyle>;
  employee: Employee;
  value?: boolean;
  onChange(): void;
  disabled?: boolean;
  searchKeyword?: string;
  testID?: string;
};

export default function CheckboxEmployee({
  disabled: _disabled,
  employee,
  style,
  value,
  onChange,
  searchKeyword = "",
  testID,
}: Props) {
  const { divisionOptions } = useTravelerPickerContextV2();

  const disabled = _disabled && !value;

  return (
    <Pressable onPress={onChange} disabled={disabled}>
      <BMView style={style} row spacing="md">
        <BMCheckbox
          testID={testID}
          onChange={onChange}
          value={value}
          disabled={disabled}
        />
        <BMView flex>
          <HighlightText
            keyword={searchKeyword}
            searchedText={employee.fullname}
            defaultTextProps={{
              variant: "uiNormal",
              ellipsizeMode: "tail",
            }}
            highlightTextProps={{
              variant: "uiNormal",
              ellipsizeMode: "tail",
              ink: "BMStyleTextInkAction",
            }}
          />
          <HighlightText
            keyword={searchKeyword}
            searchedText={[
              divisionOptions.find(
                (option) => option.value === employee.division
              )?.label ?? employee.division,
              employee.email,
            ]
              .filter(Boolean)
              .join(" - ")}
            defaultTextProps={{
              variant: "uiNormalLi",
              ellipsizeMode: "tail",
              ink: "BMStyleTextInkSecondary",
            }}
            highlightTextProps={{
              variant: "uiNormalLi",
              ellipsizeMode: "tail",
              ink: "BMStyleTextInkAction",
            }}
          />
        </BMView>
      </BMView>
    </Pressable>
  );
}
